import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import Wave from 'react-wavify'
import pic from '../img/anime.png'
import me from '../img/me.jpg'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import CSSRulePlugin from 'gsap/CSSRulePlugin'
import {Link} from 'react-scroll'
import Resume from './Resume.docx'

function Intro() {
    let pauseStatus = false;

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger,CSSRulePlugin)

        const profile = document.querySelector('.profile')
        const intro = document.querySelector('.introduction-grid')

        const timeline = gsap.timeline()
        timeline.fromTo(profile,{
            translateX:'-100%'
        },{
            translateX:"0%",
            ease:"none",
            duration:1
        })
        timeline.fromTo(intro,{
            translateX:'100%'
        },{
            translateX:"0%",
            ease:"none",
            duration:1
        },"-=1")

        const header = document.querySelector('.introduction-grid .header h1')
        const body = document.querySelectorAll('.introduction-grid .body h2')

        timeline.to(header,{y:'0%',duration:1})
        timeline.to(body,{y:'0%',delay:0.5,duration:1,stagger:0.2})

    },[])

    return (
        <div className='intro' id='intro'>
            
            <div className="navbar">
                <Link
                    className='links' 
                    activeClass="active"
                    to="intro"
                    spy={true}
                    smooth={true}
                    hashSpy={true}
                    offset={0}
                    duration={500}
                > 
                <span className='c'></span>
                Home 
                </Link>
                <Link
                    className='links' 
                    activeClass="active"
                    to="stacks"
                    spy={true}
                    smooth={true}
                    hashSpy={true}
                    offset={0}
                    duration={500}
                > 
                <span className='c'></span>
                Stack 
                </Link>
                <Link
                    className='links' 
                    activeClass="active"
                    to="project"
                    spy={true}
                    smooth={true}
                    hashSpy={true}
                    offset={0}
                    duration={500}
                > 
                <span className='c'></span>
                Project 
                </Link>
                <Link
                    className='links' 
                    activeClass="active"
                    to="contact"
                    spy={true}
                    smooth={true}
                    hashSpy={true}
                    offset={0}
                    duration={500}
                > 
                <span className='c'></span>
                Contact 
                </Link>
            </div>

            <div className="profile">
                <div className="profile-grid">
                    <div className="pic">
                        <div className="glitch">
                            <div className="glitch__item"></div>
                            <div className="glitch__item"></div>
                            <div className="glitch__item"></div>
                            <div className="glitch__item"></div>
                            <div className="glitch__item"></div>
                        </div>
                        {/* <img src={me} alt="" /> */}
                    </div>
                    <div className="media-grid">
                        <div className="media">
                            <div className="med">
                                <a href="">
                                    <ion-icon name="logo-discord"></ion-icon>
                                </a>
                            </div>
                            <div className="med">
                                <a href="https://www.facebook.com/myt.vince.3/">
                                    <ion-icon name="logo-facebook"></ion-icon>
                                </a>
                            </div>
                            <div className="med">
                                <a href="https://www.instagram.com/x_e_n_e_x_1_2/">
                                    <ion-icon name="logo-instagram"></ion-icon>
                                </a>
                            </div>
                        </div>
                        <button type='submit' className="resume"> 
                            <a href={Resume} download>
                                Resume 
                            </a>
                            <Wave
                            className='wave'
                            fill="white"
                            paused={pauseStatus}
                            options={{
                                height: 30,
                                amplitude: 15,
                                speed: 0.5,
                                points: 4
                            }}></Wave>
                        </button>
                    </div>
                </div>
            </div>
            <div className="introduction-grid">
                <div className="header">
                    <div className="hide"> 
                        <h1>
                        Hi I'm JulleMyth Vicentillo 
                        </h1>
                    </div>
                </div>
                <div className="body">
                    <div className="hide-box">
                    <Wave
                    className='wave'
                    fill="white"
                    paused={pauseStatus}
                    options={{
                        height: 50,
                        amplitude: 15,
                        speed: 0.5,
                        points: 4
                    }}></Wave>
                    <div className="hide">
                        <h2> A Freelance Web Dev/AI Automation Beginner </h2>
                    </div>
                    </div>
                    <div className="hide-box">
                    <Wave
                    className='wave'
                    fill="white"
                    paused={pauseStatus}
                    options={{
                        height: 50,
                        amplitude: 15,
                        speed: 0.5,
                        points: 4
                    }}></Wave>
                    <div className="hide">
                        <h2> I have more than 2 years experience in Python </h2>
                    </div>
                    </div>
                    <div className="hide-box">
                    <Wave
                    className='wave'
                    fill="white"
                    paused={pauseStatus}
                    options={{
                        height: 50,
                        amplitude: 15,
                        speed: 0.5,
                        points: 4
                    }}></Wave>
                    <div className="hide">
                        <h2> And 4 Months in Full Stack DEV "MERN Stack" </h2>
                    </div>
                    </div>
                    <div className="hide-box">
                    <Wave
                    className='wave'
                    fill="white"
                    paused={pauseStatus}
                    options={{
                        height: 50,
                        amplitude: 15,
                        speed: 0.5,
                        points: 4
                    }}></Wave>
                    <div className="hide">
                        <h2> I also love animation with GSAP and Parallax Effect </h2>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Intro